import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "ms-sm-auto px-md4 col-md-9 col-lg-2" }
const _hoisted_7 = { class: "justify-content-between flex-wrap flex-md-nowrap pt-3 pb-2 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_nav = _resolveComponent("top-nav")!
  const _component_app_nav = _resolveComponent("app-nav")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.state.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_top_nav),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.showAppMenu)
            ? (_openBlock(), _createBlock(_component_app_nav, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("main", {
          class: _normalizeClass([_ctx.mainClasses, "ms-sm-auto px-md-4"])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_view)
          ])
        ], 2)
      ])
    ])
  ]))
}